import { Button, Flex } from "@chakra-ui/react";
import DropDown from "components/DropDown";
import { Header } from "components/Header";
import TableList from "components/TableList";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "services/api";

const headers = ["Reg", "Make"];

// const items = [
//   {
//     id: 1,
//     Reg: "AU1",
//     Make: "ROLLS ROYCEL",
//   },
//   {
//     id: 2,
//     Reg: "FLZEZ",
//     Make: "HYUNDAI",
//   },
// ];

function ManageCar() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  // const [selectedItem, setSelectedItem] = useState();
  // const [activePage, setActivePage] = useState(1);
  // const [searchTxt, setSearchTxt] = useState("");
  // const [searchLoading, setSearchLoading] = useState(false);

  const [dealers, setDealers] = useState();
  // const [dealerid, setDealerId] = useState();

  const navigate = useNavigate();
  const onNew = () => {
    navigate("/vehicledetails", { state: { action: "managecar" } });
  };

  const onClickItm = ({ item }) => {
    // window.alert(JSON.stringify(item || ""));
  };

  const getList = async (data) => {
    setIsLoading(true);
    return api
      .getCars({
        dealerid: data?.dealerid,
      })
      .then((res) => {
        setIsLoading(false);
        if (res?.status === 200) {
          console.log(res.data);

          if (res?.data && res?.data[0]?.carid) {
            const l = res.data.map((item) => ({
              id: item.carid,
              reg: item.vrm,
              make: item.carmake,
            }));
            setList(l);
          } else {
            setList([]);
          }
        } else {
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  const onDealersChange = (data) => {
    console.log("onDealersChange", data);

    setDealers(data?.list ? [...data.list] : []);
    // setDealerId(data?.item?.data?.dealerid || "");

    // if (data?.action === "useState") {
    // } else {
    // setDealerId(data?.item?.label || "");
    // }

    if (data?.action !== "useState") {
      if (data?.item?.data?.dealerid || data?.item?.data?.dealerid === 0) {
        getList({
          dealerid: data?.item?.data?.dealerid,
          action: data?.action,
          page: 1,
        });
      } else {
        getList();
      }
    }
  };

  useEffect(() => {
    const cd = async () => {
      // await getDealers({ action: "useState" });
      await getList({ action: "useState" });
    };

    cd();
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Manage Car"} isLoading={isLoading} />
      <Flex justifyContent="space-between" gap={"3"}>
        <DropDown w={"10rem"} items={dealers} onChange={onDealersChange} />
        {/* <Add /> */}
        <Button variant="outline" onClick={onNew}>
          New
        </Button>
      </Flex>
      <TableList headers={headers} items={list} onSelect={onClickItm} />
    </Flex>
  );
}

export default ManageCar;
